export enum DistributionTypeEnum{
    Standard = 1,
    Residual = 2
}